export default __webpack_public_path__ + "static/groups-in-feature-flags-light-mode-35a63ead73bc845dea8604a28707eb66.mp4";